//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import { analytics } from "/src/main.js";
export default {
  name: "Home",
  components: {},
  data() {
    return {
      benefitsList: [
        {
          heading: "World Class Teachers",
          subheading:
            "Learn from the best, get the right information at the right time for each level.",
        },
        {
          heading: "Multiple Angles",
          subheading: "View demos from front or back to see all the details.",
        },
        {
          heading: "Sections & Speed",
          subheading:
            "Replay to exact figure and timing markers, playback at slower speeds.",
        },
        {
          heading: "Solo Practice Drills",
          subheading:
            "Library of solo drills, workouts, and practice routines, no partner needed.",
        },
      ],
    };
  },
  mounted() {
    analytics.logEvent("screen_view", {
      firebase_screen: "Marketing Page",
      firebase_screen_class: "screenClass",
    });
  },
};
